import FeatureGates from '@atlaskit/feature-gate-js-client';
import Heading from '@atlaskit/heading';
import { Anchor, Box, Stack, xcss } from '@atlaskit/primitives';
import { useFirePostOfficeAnalyticsEvents } from '@post-office/analytics';
import { JiraSideNavMessage } from '@post-office/components--jira-side-nav-message';
import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
import { useMessageEvent } from '@post-office/message-lifecycle';
import { FormattedMessage, useIntl } from 'react-intl-next';

import lightbulbIconPath from './Lightbulb.svg';
import { createRender } from './types';

const anchorStyles = xcss({
	textDecoration: 'none',
});

const boxStyles = xcss({
	marginRight: 'space.200',
});

const BodyContent = () => {
	const intl = useIntl();
	const altText = intl.formatMessage({
		id: 'jira.side.nav.onboarding.import.nudge.icon.alt',
		defaultMessage: 'Lightbulb icon indicating an import tooltip',
		description: 'Alt text for the lightbulb icon in the import work nudge',
	});

	const { fireAnalyticsEvent } = useFirePostOfficeAnalyticsEvents();
	const { messageClicked } = useMessageEvent();
	const { messageInstanceClicked } = useMessageInstanceEvent();

	const handleClick = () => {
		void messageClicked(); // DEPRECATED: https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/pre-defined-filters/#snooze-check-filter
		void messageInstanceClicked({
			messageEventType: 'clicked',
			clickedElement: {
				clickIdentifier: 'importWork',
				clickedElement: 'button',
				buttonType: 'primary',
			},
			action: {
				actionType: 'open',
				destinationUrl: '/jira/settings/system/external-import',
			},
			additionalMetadataFromFrontend: {},
		});
		fireAnalyticsEvent({
			eventType: 'ui',
			action: 'clicked',
			actionSubject: 'button',
			actionSubjectId: 'importWork',
		});
	};

	return (
		<>
			<img src={lightbulbIconPath} alt={altText} height="40px" width="40px" />

			<Stack space="space.100">
				<Box xcss={boxStyles}>
					<Heading size="xsmall">
						<FormattedMessage
							id="jira.side.nav.onboarding.import.nudge.heading"
							defaultMessage="Import work from another tool or CSV file to get started faster."
							description="Text for the onboarding invite nudge, encouraging them to import work into Jira"
						/>
					</Heading>
				</Box>

				<Anchor
					href="/jira/settings/system/external-import"
					target="_blank"
					xcss={anchorStyles}
					onClick={handleClick}
				>
					<FormattedMessage
						id="jira.side.nav.onboarding.import.nudge.link"
						defaultMessage="Import work"
						description="CTA for the onboarding invite nudge, that redirects the user to the import work screen in Jira"
					/>
				</Anchor>
			</Stack>
		</>
	);
};

export const render = createRender(() => {
	if (FeatureGates.getExperimentValue('jira_sidebar_import_nudge', 'isEnabled', false)) {
		return (
			<JiraSideNavMessage
				bodyContent={<BodyContent />}
				showRemindMeLater
				showWhyAmISeeingThis={false}
			/>
		);
	}

	return null;
});

export default render;
